<div class="dialog-container">
    <div class="dialog-header">
        <div class="dialog-header-title">
            {{ data.label }}
        </div>
    </div>

    <div class="dialog-content">

        <div class="dialog-content-description" *ngIf="data?.proposal">
            {{data?.proposal?.shortDescription}}
        </div>

        <form [formGroup]="form" class="dialog-form-content">
            <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="start center" fxLayoutAlign.lt-sm="stretch"
                class="form-group">

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Data da ação</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="date" readonly (click)="picker.open()" />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="start center" fxLayoutAlign.lt-sm="stretch"
                class="form-group">
                <mat-form-field *ngIf="data.action === 'reprovar'" appearance="outline" class="full-width">
                    <mat-label>Motivo da recusa</mat-label>
                    <textarea matInput formControlName="reason" rows="3"></textarea>
                </mat-form-field>
            </div>
        </form>

        <div fxLayout="row" fxLayoutAlign="end">

            <button mat-button type="button" mat-dialog-close>Cancelar</button>
            <button mat-raised-button class="btn btn-green" type="submit" [disabled]="form.invalid" (click)="confirm()">
                Confirmar
            </button>

        </div>

    </div>
</div>